module.exports = __webpack_public_path__ + "6fb753562c7da0bf8b99b2960f98836d.svg";